export default "__VITE_ASSET__BSw0dSha__"